
import React from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

interface MobileMenuButtonProps {
  isMenuOpen: boolean;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ isMenuOpen, setIsMenuOpen }) => {
  return (
    <Button
      variant="ghost"
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      className="inline-flex h-12 w-12 items-center justify-center rounded-[0.875rem] border border-[#E3EDF3] bg-[#F9FCFE] p-0 text-[#3EA8F2] shadow-[0_0.5rem_1.25rem_rgba(62,168,242,0.08)] hover:bg-[#EAF5FD] hover:text-[#3398DF] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#3EA8F2]"
      size="sm"
      aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
    >
      {isMenuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
    </Button>
  );
};

export default MobileMenuButton;
